import { ModelBase } from '../../core/model/model-base';

export class CompanyCostPlace extends ModelBase {
  costPlace: string;
}
export class CompanyCostBearer extends ModelBase {
  costBearer: string;
}
